"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINE_CHART_COLORS = void 0;
var style_1 = require("../../../../style");
exports.LINE_CHART_COLORS = [
    style_1.DesignSystemColor.Teal.LIGHT_1,
    style_1.DesignSystemColor.Blue.LIGHT_1,
    style_1.DesignSystemColor.Green.LIGHT_3,
    style_1.DesignSystemColor.Pink.LIGHT_2,
    style_1.DesignSystemColor.Violet.LIGHT_3,
    style_1.DesignSystemColor.Yellow.LIGHT_3,
    style_1.DesignSystemColor.Red.LIGHT_2,
    style_1.DesignSystemColor.Pink.LIGHT_1,
    style_1.DesignSystemColor.Violet.LIGHT_2,
    style_1.DesignSystemColor.Blue.LIGHT_3,
];
